import { Stack } from '@mui/material';
import SettingCard from '@/components/SettingCard';
import ClassSettings from '@/components/editor/settings/ClassSettings';
import ButtonSettings from '@/components/editor/settings/ButtonSettings/ButtonSettings';

export const ButtonBlockSettings = () => {
  return (
    <Stack spacing={2}>
      {/* ✅ */}
      <SettingCard title="Clase Css">
        <ClassSettings />
      </SettingCard>
      <SettingCard title="Botón">
        <ButtonSettings />
      </SettingCard>
    </Stack>
  );
};

export default ButtonBlockSettings;
